import React from 'react'
import { connect } from 'react-redux'
import { Comment, Form , Message, Image , Table, Popup, Button} from 'semantic-ui-react'
import { sendChatMessage } from '../reducers/chatMessages';
import { moderateUser } from '../reducers/user/actions';
import Autoscroll from './Autoscroll'
// ADD F.L. 14/11/2018
import Roles from '../models/Roles'
import "./LiveVideoChat.css"

class ChatForm extends React.Component {
    state = { text: ''}
    
    handleChange = (e, { name, value }) => this.setState({ [name]: value })
    handleSubmit = (e) => {
        const { socket, onSend } = this.props
        const { text } = this.state
        e.preventDefault();
        onSend(socket, { text })
        this.setState({ text: '' })
    }


    render() {
        const { text } = this.state
        if (this.props.is_banned === 1){
            return (<Message
                warning
                header='Chat disattivata'
                content='Mi spiace, ma sei stato bannato perchè ti sei comportato da discolo!'
            /> )
        }else if (!(this.props.canChat)) {
            var numOfChatters = this.props.numOfChatters;
            return (<Message
                warning
                header='Chat disattivata'
                content= 'Non sei abbastanza in alto in classifica per chattare'
            />) 
        
        } else if (this.props.enabled){
            return (
              <Form onSubmit={this.handleSubmit}>
                 <Form.Input fluid autoComplete='off' action='Invia' name='text' 
                        placeholder='Messaggio' value={text} onChange={this.handleChange}
                        style={{ marginBottom: 0 }} />
             </Form>
            )
        }else {
            return (
                <Message
                warning
                header='Chat disattivata'
                content='Non puoi usare la chat mentre una domanda è in corso'
              />
            )
        }
    }
}
class ChatMessage extends React.Component { 
    
    handleBan = (e, {user_id}) => {
        const {socket, moderateUser} = this.props
        e.preventDefault();
        moderateUser(socket, {user_id});
    }

    render() {

     const  { message, user, bannedplayers } = this.props;
     
     return(
       <Table.Row verticalAlign='top'>
        <Table.Cell collapsing>
            {(message.from.roles && message.from.roles.indexOf(Roles.HOST) === -1) &&
            (user.roles && user.roles.indexOf(Roles.HOST) !== -1) &&
            (message.from.roles && message.from.roles.indexOf(Roles.SYSTEM) === -1)
            ? 
            <Popup
                trigger={<Image src={message.from.avatar} size = 'mini' circular/>}
                content={ ((bannedplayers[message.from.id])? 
                            <Button 
                                color= 'green' 
                                content='De-Ban this user' 
                                user_id = {message.from.id} onClick = {this.handleBan}/>
                :
                            <Button 
                                color= 'red' 
                                content='Ban this user' 
                                user_id = {message.from.id} onClick = {this.handleBan}/>
                )}
                on='click'
                position='top right'
            />
            : 
            <Image src={message.from.avatar} size = 'mini' circular/> 
            }
        </Table.Cell> 
        <Table.Cell>
        <Comment style={{ textAlign: 'left' }}>
        <Comment.Content>       
            {message.from.roles && message.from.roles.indexOf(Roles.HOST) !== -1 ? 
                <Comment.Author> <div class="conduttore">{message.from.username}{user.id === message.from.id ? <Comment.Metadata>Tu</Comment.Metadata> : null}  </div></Comment.Author>
            :
              ( message.from.roles && message.from.roles.indexOf(Roles.SYSTEM) !== -1 ?
                <Comment.Author> <div class="sistema">{message.from.username}</div></Comment.Author>
                :<Comment.Author style={{ opacity: 0.4, fontWeight: 'normal' }}> {message.from.username} {user.id === message.from.id ? <Comment.Metadata> Tu </Comment.Metadata> : null} </Comment.Author>
              )
            }
            {message.from.roles && message.from.roles.indexOf(Roles.HOST) !== -1 ? 
                <Comment.Text><div class="conduttoreTXT"> {message.text}</div></Comment.Text> 
                :
                (
                  message.from.roles && message.from.roles.indexOf(Roles.SYSTEM) !== -1 ?
                    <Comment.Text><div class="sistemaTXT"> {message.text}</div></Comment.Text> :
                    <Comment.Text><div> {message.text}</div></Comment.Text>                 
                ) 
            }
        </Comment.Content>
    </Comment>
    </Table.Cell>
    </Table.Row>
     )
  }
}

const groupMessages = (messages) => {
    const groups = []
    let lastGroup
    messages.forEach(message => {
        if (!lastGroup || lastGroup.from.id !== message.from.id) {
            lastGroup = { ...message, text: [<div key={message.id}>{message.text}</div>] }
            groups.push(lastGroup)
        } else {
            lastGroup.text.push(<div key={message.id}>{message.text}</div>)
        }
    })
    return groups
}

// MODIFY F.L. 14/11/2018
const Chat = ({ chatMessages, socket, user, onSend, enabled, bannedplayers, isCond, canChat }) => {
    let styl = null;
    isCond? styl = { height: '100%', display: 'flex', flexDirection: 'column', flex: '1 1 150px' }:
        styl = {  display: 'flex', flexDirection: 'column', flex: '1 1 150px' }
    return (<div style={styl}>
            <Autoscroll style={{ overflow: 'auto', display: 'flex', flexDirection: 'column', flex: '1 1 1px' }}>
                <div style={{ flex: 1 }} />
                <Comment.Group>
                <Table basic='very' striped compact = {'very'} unstackable>
                {groupMessages(chatMessages).map(message => <ChatMessage key={message.id} message={message} user={user} socket={socket} bannedplayers = {bannedplayers} moderateUser = {moderateUser}/>)}
                </Table>
                 </Comment.Group>
            </Autoscroll>
            <ChatForm socket={socket} onSend={onSend} moderateUser = {moderateUser} enabled = {enabled} is_banned={(user && user.exp_user)?user.exp_user.is_banned:0} canChat={canChat}/>
        </div>
    )
    
}

const mapStateToProps = ({ chatMessages, socket, user,bannedplayers }) => ({
    user,
    chatMessages,
    socket,
    bannedplayers,
})

const mapDispatchToProps = (dispatch) => ({
    onSend: (socket, { text }) => dispatch(sendChatMessage(socket, { text })),
    moderateUser: (socket, {user_id}) => dispatch(moderateUser(socket,{user_id}))
})


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Chat)


// WEBPACK FOOTER //
// ./src/components/LiveVideoChat.js